import { Switch, useParams } from "react-router-dom"
import { css, cx } from "@emotion/css"
import { styledTabClasses, styledTabsProps } from "components/Tabs"

import { AuthorizedRoute } from "components/AuthorizedRoute"
import { Surface } from "components/Surface"
import { TabLink } from "components/Link"
import Tabs from "@material-ui/core/Tabs"
import Targets from "./Targets"
import { Universes } from "./Universes"
import { useI18n } from "providers/I18n"

const tabs = [
  "targets" /* t(company.tabs.targets) */,
  "universe" /* t(company.tabs.universe) */,
]

export function TargetDetails() {
  const { t } = useI18n()
  const { tab = "targets" } = useParams<{ tab: string }>()

  return (
    <>
      <Surface flexDirection="row" className={styles.wrapper}>
        <div className={styles.main}>
          <Tabs
            value={tab}
            {...styledTabsProps}
            classes={{
              ...styledTabsProps.classes,
              flexContainer: cx(styledTabsProps?.classes?.flexContainer),
            }}
            scrollButtons="auto"
          >
            {tabs.map((tab, idx) => (
              <TabLink
                key={idx}
                to={`/market-targets/${tab}`}
                classes={styledTabClasses}
                value={tab}
                label={t(`company.tabs.${tab}`)}
              />
            ))}
          </Tabs>
          <div>
            <Switch>
              <AuthorizedRoute
                allowed={["AUTH_VIEW_TARGET"]}
                component={Targets}
                path="/market-targets/targets"
              />
              <AuthorizedRoute
                allowed={["AUTH_VIEW_UNIVERSE"]}
                component={Universes}
                path="/market-targets/universe"
              >
                <Surface className={styles.surface}>
                  <Universes />
                </Surface>
              </AuthorizedRoute>
            </Switch>
          </div>
        </div>
      </Surface>
    </>
  )
}

const styles = {
  btn: css`
    > span {
      text-transform: capitalize;
    }
  `,
  main: css`
    flex: 1;
    display: flex;
    flex-direction: column;
  `,
  tabContent: css`
    margin-top: var(--spacing-xs);
  `,
  surface: css`
    padding: var(--spacing-xxl-2) 0px 0px;
  `,
  wrapper: css`
    padding: var(--spacing-xl) var(--spacing-m) var(--spacing-m);
  `,
}
